<script setup>
import { onMounted, ref } from "vue";

defineProps({
    modelValue: String,
});

defineEmits(["update:modelValue"]);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute("autofocus")) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <input
        ref="input"
        class="h-11 w-full rounded-brand border border-[#a79e9b] bg-white px-3 font-brand text-[15px] text-[#3c3938] focus:border-brand-navy focus:ring-1 focus:ring-brand-navy"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    />
</template>
